// extracted by mini-css-extract-plugin
export default {"container":"BagelSmsConsentForm_container__D7pRr","headerContainer":"BagelSmsConsentForm_headerContainer__IncvN","consentRow":"BagelSmsConsentForm_consentRow__Ep6cz"};